<template>
  <div
    v-if="message || $slots.default"
    :class="['alert-banner', `alert-banner--${type}`]"
    role="alert"
  >
    <span class="alert-banner__icon" aria-hidden="true">{{ icon }}</span>
    <span class="alert-banner__text">
      {{ message }}
      <slot />
    </span>
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "AlertBanner",
  props: {
    message: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "success",
      validator: (v) => ["success", "error", "info", "warning"].includes(v),
    },
  },
  setup(props) {
    const icon = computed(() => {
      switch (props.type) {
        case "error":
          return "✕";
        case "warning":
          return "⚠";
        case "info":
          return "ℹ";
        default:
          return "✓";
      }
    });
    return { icon };
  },
});
</script>

<style scoped>
.alert-banner {
  display: flex;
  align-items: flex-start;
  gap: 1.2rem;
  padding: 1.4rem 1.6rem;
  border-radius: 1rem;
  background-color: #ffffff;

  color: #1f2937;
  border: 1px solid rgba(148, 163, 184, 0.28);
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06);
  margin-bottom: 2rem;
}

.alert-banner--success {
  border-left: 4px solid #1646a3;
  box-shadow: 0 4px 16px rgba(22, 163, 74, 0.12);
}

.alert-banner--error {
  border-left: 4px solid #dc2626;
  box-shadow: 0 4px 16px rgba(220, 38, 38, 0.12);
}

.alert-banner--info {
  border-left: 4px solid #2563eb;
  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.12);
}

.alert-banner--warning {
  border-left: 4px solid #d97706;
  box-shadow: 0 4px 16px rgba(217, 119, 6, 0.12);
}

.alert-banner__icon {
  flex: 0 0 auto;
  font-size: 1.5rem;
  line-height: 1.4;
}

.alert-banner--success .alert-banner__icon {
  color: #16a34a;
}
.alert-banner--error .alert-banner__icon {
  color: #dc2626;
}
.alert-banner--info .alert-banner__icon {
  color: #2563eb;
}
.alert-banner--warning .alert-banner__icon {
  color: #d97706;
}

.alert-banner__text {
  flex: 1 1 auto;
  font-size: 1.45rem;
  line-height: 1.5;
}
</style>
